module.exports = __webpack_public_path__ + "static/media/water.3db14fd4.svg";